import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import Report from "../views/Report.vue";
import Question from "../views/Question.vue";
import landingPage from "../views/landingPage/index.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/landingPage",
    name: "landingPage",
    component: landingPage,
    meta: {
      title: "落地页",
    },
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "个人形象档案",
    },
  },
  {
    path: "/question",
    name: "question",
    component: Question,
    meta: {
      title: "形象问卷分析",
    },
  },
  {
    path: "/report",
    name: "report",
    component: Report,
    meta: {
      title: "形象报告",
    },
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "授权登录",
    },
    component: () => import("../views/userCenter/login"),
  },
  {
    path: "/author",
    name: "author",
    meta: {
      title: "授权",
    },
    component: () => import("../views/userCenter/author"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
